import React, { Fragment, Component } from 'react'
import Select from 'react-select'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import  MapPicker  from '../../../../helpers/ui/MapPicker'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'


class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            gagal_txt : '',
            location: null,
            polygon : []
        }
    }

    handleLocationSelect = (loc) => {
        this.setState({ location: loc });
      };

    

    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }
    // checkData = async () => {
    //     await this.createBloc.fetchCheck(this.state.dataForm)
    // }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        // console.log(values)
        // return 

        this.setState({
            dataForm: values,
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        this.setState({
            gagal_txt: "Gagal!"
        })
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    // alert('aaaaaaaaaaaa')
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        gagal_txt: "Gagal!",
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
        // this.createBloc.checkChannel.subscribe((result) => {
        //     switch (result.status) {
        //         case apiResponse.COMPLETED:
        //             console.log(result.data.response)
        //             // this.setState({
        //             //     loading: false,
        //             //     success: true,
        //             // });
        //             if(result.data.response==0){
        //                 this.submitData()
        //             }else{
        //                 this.setState({
        //                     gagal_txt: "Tanggal Hari Libur Sudah ada",
        //                     loading: false,
        //                     failed: true,
        //                 });
        //             }
        //             break
        //         case apiResponse.ERROR:
        //             this.setState({
        //                 gagal_txt: "Gagal!",
        //                 loading: false,
        //                 failed: true,
        //             });
        //             break
        //         default:
        //             break
        //     }
        // })
    }

    componentWillUnmount() {
        this.createBloc.createChannel.unsubscribe()
    }
    
    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>Form Tambah Data Lokasi Absen Mobile</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Tambah data Lokasi Absen Mobile 
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama Lokasi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="presensi_location_name"
                                                    placeholder="Nama Lokasi..."
                                                    type="text"
                                                    errorMessage="Nama Lokasi wajib diisi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="presensi_location_name"
                                                />
                                            </Col>
                                        </Row>
                                        
                                        {/* <Row className="mb-3">
                                            <label
                                                htmlFor="fielCode"
                                                className="col-md-3 col-form-label"
                                            >
                                            Toleransi Radius <span className="text-danger">*</span>
                                            <br/>
                                            (dalam meter)

                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="presensi_location_radius_meters"
                                                    placeholder="Toleransi Radius..."
                                                    type="number"
                                                    errorMessage="Toleransi Radius wajib diisi"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="presensi_location_radius_meters"
                                                />
                                            </Col>
                                        </Row> */}

                                        <Row className="mb-3">
                                            <label htmlFor="fieldTitle" className="col-md-3 col-form-label">
                                                Titik GPS <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <MapPicker 
                                                mode="edit"
                                                onLocationSelect={this.handleLocationSelect} 
                                                onPolygonChange={(coords) => {
                                                    this.setState({ polygon: coords });
                                                }}
                                                
                                                />
                                                
                                                <AvField
                                                type="hidden"
                                                name="presensi_geolocation"
                                                value={
                                                    this.state.polygon && this.state.polygon.length > 0
                                                    ? JSON.stringify(this.state.polygon)
                                                    : ""
                                                }
                                                validate={{
                                                    required: {
                                                    value: true,
                                                    errorMessage: "Polygon area wajib digambar sebelum submit!"
                                                    }
                                                }}
                                                />

                                            </Col>
                                            </Row>

                                            {/* {this.state.location && (
                                            <Row className="mb-3">
                                                <Col md={{ span: 6, offset: 3 }}>
                                                <div className="p-2 bg-light border rounded">
                                                    <strong>Latitude:</strong> {this.state.location.lat} <br />
                                                    <strong>Longitude:</strong> {this.state.location.lng}
                                                </div>
                                                </Col>
                                            </Row>
                                            )} */}
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/master/presensi_lokasi.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    // failedTitle="Gagal!"
                    failedTitle={this.state.gagal_txt}
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/presensi_lokasi.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView